import styled from "styled-components";

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: ${({ theme }) => theme.spacing.small};

  & > * {
    height: 100%;
  }

  @media (max-width: 400px) {
    grid-template-columns: 1fr;
  }
`;

export const CardWide = styled.div`
  grid-column: span 2;

  & > * {
    height: 100%;
  }

  @media (max-width: 400px) {
    grid-column: span 1;
  }
`;
